import { useEffect } from "react";

import { useSelector } from "react-redux";

import leadsSearchFiltersTrackingService from "app/pages/sales-intelligence/modules/leads-search-filters/services/tracking/trackingService";
import { selectNumberOfSignalsFromSource } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

export const useLeadsFiltersTrackingServiceSync = () => {
    const numberOfAllSignals = useSelector(selectNumberOfSignalsFromSource);

    useEffect(() => {
        leadsSearchFiltersTrackingService.setSignalsCount(numberOfAllSignals);
    }, [numberOfAllSignals]);
};
